import React, { useContext, useEffect, useMemo } from 'react';
import _ from 'lodash';
import Table from '../../Shared/Table';
import { OperationsContext } from '../OperationsContext';
import RenewalClientStats from './RenewalClientStats';

const ReviewTab = () => {
	const {
		renewalClients,
		tableLoader,
		getRenewalClients,
		getRenewalClient,
		setRenewalStep
	} = useContext( OperationsContext );

	useEffect( () => {
		getRenewalClients();
	}, [ getRenewalClients ] );

	const columns = useMemo( () => [
		{
			id: 'name',
			Header: (
				<div
					style={{
						fontWeight: 600,
						color: '#374151'
					}}
				>
					Client Name
				</div>
			),
			accessor: row => `${ row.name }`,
			filterable: true,
			filterMethod: ( filter, row ) => _.includes( row._original.name.toUpperCase(), filter.value.toUpperCase() ),
			sortable: true,
			Cell: row => <div style={{ whiteSpace: 'normal' }}>{ row.original.name }</div>,
			style: { whiteSpace: 'unset' },
			width: 280
		},
		{
			id: 'currentTier',
			Header: (
				<div
					style={{
						fontWeight: 600,
						color: '#374151'
					}}
				>
					Current Tier
				</div>
			),
			accessor: row => `${ row.currentTier }`,
			sortable: true,
			Cell: row => <div style={{ whiteSpace: 'normal' }}>{ row.original.currentTier }</div>,
			style: { whiteSpace: 'unset' }
		},
		{
			id: 'suggestedTier',
			Header: (
				<div
					style={{
						fontWeight: 600,
						color: '#374151'
					}}
				>
					Suggested Tier
				</div>
			),
			accessor: row => `${ row.suggestedTier }`,
			sortable: true,
			Cell: row => <div style={{ whiteSpace: 'normal' }}>{ row.original.suggestedTier }</div>,
			style: { whiteSpace: 'unset' }
		},
		{
			id: 'proposedTier',
			Header: (
				<div
					style={{
						fontWeight: 600,
						color: '#374151'
					}}
				>
					Proposed Tier
				</div>
			),
			accessor: row => `${ row.proposedTier }`,
			sortable: true,
			Cell: row => <div style={{ whiteSpace: 'normal' }}>{ row.original.proposedTier }</div>,
			style: { whiteSpace: 'unset' }
		},
		{
			id: 'premiumImpact',
			Header: (
				<div
					style={{
						fontWeight: 600,
						color: '#374151'
					}}
				>
					Premium Impact
				</div>
			),
			accessor: row => `${ row.premiumImpact }`,
			sortable: true,
			Cell: row => <div style={{ whiteSpace: 'normal' }}>{ row.original.premiumImpact }</div>,
			style: { whiteSpace: 'unset' }
		},
		{
			id: 'reviewStatus',
			Header: (
				<div
					style={{
						fontWeight: 600,
						color: '#374151'
					}}
				>
					Status
				</div>
			),
			accessor: row => row.reviewStatus,
			sortable: true,
			Cell: row => {
				const value = row.original.reviewStatus;

				const color
					= value === 'Final'
						? '#16a34a'
						: value === 'In Progress'
							? '#e7e7e7'
							: '#e7e7e7';

				return (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontWeight: 500
						}}
					>
						<span
							style={{
								width: 8,
								height: 8,
								borderRadius: '50%',
								background: color,
								marginRight: 8
							}}
						/>

						{value}
					</div>
				);
			},
			style: { whiteSpace: 'unset' }
		},
		{
			id: 'risk',
			Header: (
				<div
					style={{
						fontWeight: 600,
						color: '#374151'
					}}
				>
					Risk
				</div>
			),
			accessor: row => row.risk,
			sortable: true,
			Cell: row => {
				const value = row.original.risk;

				const color
					= value === 'High'
						? '#dc2626'
						: value === 'Medium'
							? '#d97706'
							: '#16a34a';

				return (
					<div
						style={{
							fontWeight: 600,
							color,
							textAlign: 'center'
						}}
					>
						{value}
					</div>
				);
			},
			style: { whiteSpace: 'unset' }
		}
	], [] );

	return (
		<div>
			<RenewalClientStats />
			<Table
				data={ renewalClients }
				columns={ columns }
				loading={ tableLoader }
				// ref={ prospectsTable }
				// onFilteredChange={ () => {
				// 	const customerIds = prospectsTable?.current.getResolvedState().sortedData.map( ( { id } ) => id );

				// 	setFilteredCustomers( customerIds );
				// }}
				getTrProps={( state, rowInfo ) => ( {
					onClick: () => {
						if ( rowInfo ) {
							getRenewalClient( rowInfo.original.clientID );
							setRenewalStep( 1 );
						}
					},
					onMouseEnter: e => {
						e.currentTarget.style.background = '#f5f9ff';
					},
					onMouseLeave: e => {
						e.currentTarget.style.background = '#fff';
					},
					style: {
						cursor: 'pointer',
						background: '#fff',
						transition: 'background-color .15s ease'
					}
				} )}
			/>
		</div>
	);
};

export default ReviewTab;
